/*
 *
 * Qualification constants
 *
 */

export const SLICE_NAME = 'qualification';
